/** The value of a design token on the document root, e.g. `getCssVar('background')` for `--background`. */
export function getCssVar(name: string): string {
  if (typeof window === 'undefined') return ''
  return getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim()
}
